<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Add Details"
            bc1="App"
            bc2="Roles"
            bc3="Add"
            path="roles"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                  type="text"
                                  v-model="name"
                                  id="name-icon"
                                  class="form-control"
                                  :class="
                                  errorBag.has('name') ? 'is-invalid' : ''
                                "
                                  name="name"
                                  placeholder="Name"
                                  v-validate="'required'"
                              />
                              <small
                                  v-show="errorBag.has('name')"
                                  class="invalid-feedback"
                              >{{ "*" + errorBag.first("name") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="dsname-icon">Display Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <input
                                  type="text"
                                  v-model="displayName"
                                  id="dsname-icon"
                                  class="form-control"
                                  :class="
                                  errorBag.has('displayName') ? 'is-invalid' : ''
                                "
                                  name="displayName"
                                  placeholder="Display Name"
                                  v-validate="'required'"
                              />
                              <small
                                  v-show="errorBag.has('displayName')"
                                  class="invalid-feedback"
                              >{{ "*" + errorBag.first("displayName") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
<!--                      <div class="col-12">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3 col-form-label">-->
<!--                            <label>Type</label>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="input-group">-->
<!--                              <select-->
<!--                                  v-model="type"-->
<!--                                  size="sm"-->
<!--                                  name="type"-->
<!--                                  v-validate="'required'"-->
<!--                                  class=form-control-->
<!--                                  :class="-->
<!--                                  errorBag.has('type') ? 'is-invalid' : ''-->
<!--                                "-->
<!--                              >-->
<!--                                <option value=""-->
<!--                                >Please Select Type-->
<!--                                </option>-->
<!--                                <option-->
<!--                                    v-for="(item, index) in options"-->
<!--                                    :value="item.id"-->
<!--                                    :key="index"-->
<!--                                >{{ item.text }}-->
<!--                                </option>-->
<!--                              </select>-->
<!--                              <small-->
<!--                                  v-show="errorBag.has('type')"-->
<!--                                  class="invalid-feedback"-->
<!--                              >{{ "*" + errorBag.first("type") }}</small-->
<!--                              >-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="col-12">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3 col-form-label">-->
<!--                            <label>Status</label>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="input-group">-->
<!--                              <select-->
<!--                                  v-model="status"-->
<!--                                  name="status"-->
<!--                                  v-validate="'required'"-->
<!--                                  class=form-control-->
<!--                                  :class="-->
<!--                                  errorBag.has('status') ? 'is-invalid' : ''-->
<!--                                "-->
<!--                              >-->
<!--                                <option value=""-->
<!--                                >Please Select Status-->
<!--                                </option>-->
<!--                                <option :value="1"-->
<!--                                >Active-->
<!--                                </option>-->
<!--                                <option :value="0"-->
<!--                                >Inactive-->
<!--                                </option>-->
<!--                              </select>-->
<!--                              <small-->
<!--                                  v-show="errorBag.has('status')"-->
<!--                                  class="invalid-feedback"-->
<!--                              >{{ "*" + errorBag.first("status") }}</small-->
<!--                              >-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="col-12">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3 col-form-label">-->
<!--                            <label>Make Default</label>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="custom-control custom-switch mb-1">-->
<!--                              <input id="id_1" type="checkbox"  :true-value="1" :false-value="0" v-model="defaultStatus"-->
<!--                                     class="custom-control-input"/>-->
<!--                              <label class="custom-control-label"-->
<!--                                     for="id_1">-->

<!--                              </label>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-9 offset-sm-3 text-right d-flex">
                            <button
                                type="button"
                                class="btn btn-primary mr-1 d-flex"
                                @click="sendCall"
                                :disabled="loading"
                            >
                              <Loader :loading="loading" :size="size"></Loader>
                              Save
                            </button>
                            <button
                                type="button"
                                class="btn btn-gradient-secondary"
                                @click="$router.push({ name: 'roles' })"
                            >
                              Back
                            </button>
                          </div>
                        </div>

                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>


export default {
  mounted() {

  },
  data() {
    return {
      name: "",
      displayName: "",
      status: "",
      type: "",
      defaultStatus:0,
      loading: false,
      size: "10px",
      options: [
        { id: 1, text: "Admin" },
        { id: 2, text: "User" },
        { id: 3, text: "Merchant" }
      ]
    };
  },

  methods: {
    sendCall() {
      this.$validator.validateAll().then(valid => {
        let data = {
          name: this.name,
          display_name: this.displayName,
          // status: this.status,
          // type: this.type,
          // is_default: this.defaultStatus,
        }

        this.loading = true

        this.makeRequest("post", "v1/create-role", data).then(callResponse => {
          if (!callResponse.error) {
            let code = callResponse.response.data.code;
            if (code == 200) {
              this.$router.push({
                name: "roles",
              });
            }
          }
          this.loading = false;
        });
      });
    }
  }
};
</script>

